import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { CalendarPage } from './CalendarPage'
import { LoadPage } from './LoadPage'
import { RulesPage } from './RulesPage'

export const routes: RouteObject[] = [
  { path: '/plan/calendar', element: <CalendarPage /> },
  { path: '/plan/load', element: <LoadPage /> },
  { path: '/plan/rules', element: <RulesPage /> },
]

// Раздел «План»: голый /plan ведёт на первую вкладку — календарь.
const tab = (path: string, label: string, icon: NavItem['icon'], order: number): NavItem => ({
  path,
  label,
  icon,
  mobile: null,
  order,
  parent: '/plan',
})

export const nav: NavItem[] = [
  { path: '/plan', label: 'План', icon: 'plan', mobile: 'tab', order: 30 },
  tab('/plan/calendar', 'Календарь', 'plan', 10),
  tab('/plan/load', 'Нагрузка', 'chart', 20),
  tab('/plan/rules', 'Расписание', 'list', 30),
]
